import { render, staticRenderFns } from "./EmailBroadcastEditorPage.vue?vue&type=template&id=315f5dad&scoped=true"
import script from "./EmailBroadcastEditorPage.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastEditorPage.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastEditorPage.vue?vue&type=style&index=0&id=315f5dad&prod&lang=scss&scoped=true"
import style1 from "./EmailBroadcastEditorPage.vue?vue&type=style&index=1&id=315f5dad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f5dad",
  null
  
)

export default component.exports